// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__KpzhW","content":"LoginPage_content__8yaEM"};